import type { OpsUserSummary } from '../../api/types';
import { useTranslation } from 'react-i18next';
import { opsUserInitials, opsUserName } from './opsUser';
import styles from './OwnerChip.module.css';

interface Props {
  owner: OpsUserSummary | null | undefined;
  /** Current user's ops id — marks the chip as "(you)". */
  meId?: number | null;
  emptyLabel?: string;
}

/** Avatar chip (initials + name) for an ops owner / account manager. */
export function OwnerChip({ owner, meId, emptyLabel = 'Unassigned' }: Props) {
  const { t } = useTranslation();
  if (!owner) return <span className={styles.unassigned}>{emptyLabel}</span>;
  const self = meId != null && owner.id === meId;
  const name = opsUserName(owner);
  return (
    <span className={self ? `${styles.chip} ${styles.self}` : styles.chip} title={owner.email}>
      <span className={styles.avatar} aria-hidden="true">
        {opsUserInitials(owner)}
      </span>
      <span className={styles.name}>
        {name}
        {self && <span className={styles.you}>{' '}{t('ownership.ownerChip.you')}</span>}
      </span>
      {owner.status === 'AWAY' && <span className={styles.away}>{t('ownership.ownerChip.away')}</span>}
    </span>
  );
}
